import { SvgIcon } from '@/components'
import React from 'react'
import styled from 'styled-components'
import { t } from '@/i18n'

interface StepIndicatorProps {
  currentStep: number
}

const StepIndicator: React.FC<StepIndicatorProps> = ({ currentStep }) => (
  <Wrapper>
    <div className="title">{t('创建任务')}</div>
    <div className="steps-container">
      <div className={currentStep === 1 ? 'step-number active' : 'step-number'}>01</div>
      <div className={currentStep === 1 ? 'step-number' : 'step-number active'}>02</div>
      <div className="step-icon-wrapper">
        <SvgIcon className="step-icon" width="40px" height="40px" name={'任务配置'} />
        <span className={currentStep === 1 ? 'step-text active' : 'step-text'}>
          {t('任务配置')}
        </span>
      </div>
      <div className="step-arrow">
        <SvgIcon
          width="24"
          height="28"
          name={currentStep === 1 ? 'step-arrow-normal' : 'step-arrow-active'}
        />
      </div>
      <div className="step-icon-wrapper">
        <SvgIcon
          className="step-icon"
          width="40px"
          height="40px"
          name={currentStep === 1 ? '模版及用例选择灰' : '模版及用例选择'}
        />
        <span className={currentStep === 1 ? 'step-text' : 'step-text active'}>
          {t('模板及用例选择')}
        </span>
      </div>
    </div>
  </Wrapper>
)

export default StepIndicator

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 14px 16px 0;

  .title {
    font-weight: 500;
    font-size: 16px;
  }

  .steps-container {
    width: 46.4%;
    height: 76px;
    margin: 16px auto;
    padding: 0 6.2%;
    background: rgba(66, 56, 201, 0.04);
    border: 1px dashed #afabe8;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    position: relative;

    .step-number {
      width: 28px;
      height: 28px;
      text-align: center;
      line-height: 28px;
      font-size: 20px;
      font-weight: 500;
      color: #86909c;
      background: rgba(255, 255, 255, 0.5);
      font-family: 'DIN Alternate', apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
        'Helvetica Neue', Arial, 'Noto Sans', sans-serif;
      font-style: italic;

      &.active {
        color: #4238c9;
      }

      &:first-child {
        position: absolute;
        left: 12%;
        top: -18px;
      }

      &:nth-child(2) {
        position: absolute;
        left: 60%;
        top: -18px;
      }
    }

    .step-icon-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;

      .step-icon {
        margin-right: 10px;
      }

      .step-text {
        margin-right: 60px;
        color: #999;
        flex-shrink: 0;

        &.active {
          color: #333;
        }

        &:last-child {
          margin-right: 0;
        }
      }
    }

    .step-arrow {
      margin: 0 30px;
    }
  }
`
